"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const filterComponentsByFormat = _ref => {
  let {
    components,
    format
  } = _ref;
  return components?.filter(component => {
    if (component.format) {
      return component.format?.includes(format);
    } else {
      return true;
    }
  });
};
var _default = exports.default = filterComponentsByFormat;